import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje, MensajeCapcha, MensajeSiNo } from '../mensajes';
import { Loader, Dimmer } from 'semantic-ui-react';
import { ValidCaptcha } from '../../util/varios';
import axios from 'axios';

export const CambiarClave = props => {

    const btnCancela = useRef();
    const btnAcepta = useRef();
    const [mostrar, setMostrar] = useState(false);
    const [deshabilitado, setDeshabilitado] = useState(true);
    const [deshabilitadoL, setDeshabilitadoL] = useState(false);
    const [titulo, setTitulo] = useState();
    const [idUsuario, setIdUsuario] = useState();
    const [msg, setMsg] = useState();
    const [mostrar1, setMostrar1] = useState(false);
    const [mostrar2, setMostrar2] = useState(false);
    const [mostrar3, setMostrar3] = useState(false);
    const [mostrar4, setMostrar4] = useState(false);
    const [titulo2, setTitulo2] = useState();
    const [msg2, setMsg2] = useState();
    const [activate, setActivate] = useState(false);
    const [contar, setContar] = useState(0);
    const [contar3, setContar3] = useState(0);
    const [contar4, setContar4] = useState(0);
    const [datosEfis, setDatosEfis] = useState([]);
    const [mostrarClave, setMostrarClave] = useState(false);
    const [mostrarClave1, setMostrarClave1] = useState(false);
    const [titulo1, setTitulo1] = useState();
    const [msg1, setMsg1] = useState();
    const [tecla, setTecla] = useState();
    const [desde, setDesde] = useState(0);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const txtLogin = useRef();
    const txtPassword = useRef();
    const txtConfirmPassword = useRef();

    let op = require('../../../public/modulos/datos');
    let token = sessionStorage.getItem('jwtToken');


    const procesarRegistro = () => {

        let endpoint = `${op.conexion}/api/athos/usuario/cambiarclave`;

        let body = {
            usuario: txtLogin.current.value,
            clave: txtPassword.current.value,
           
        };

        axios.post(endpoint, body, {
            headers: {
                'x-access-token': `${token}`
            }
        }).then(function (response) {

            if (response.status == 200) {
                setActivate(false);
                setMensaje({ mostrar: true, titulo: 'Cambiar Contraseña', texto: 'La Contraseña fue cambiada.', icono: 'exito' });
            }

        }).catch(function (error) {

            setActivate(false);
            setMensaje({ mostrar: true, titulo: 'Cambiar Contraseña', texto: error.response.data.message, icono: 'error' });

        })

    }

    const SelectUsuario = (login) => {

        let endpoint = `${op.conexion}/api/comun/selectusuariologin?login=${login}`;

        axios.get(endpoint, {
            headers: {
                'x-access-token': `${token}`
            }
        }).then((response) => {

            if (response.status == 200) {
                setActivate(false);
                if (response.data.idusuario > 0) {
                    setDeshabilitado(false);
                    setDeshabilitadoL(true);
                    txtLogin.current.value = response.data.login
                    setIdUsuario(response.data.idusuario)
                    if (tecla === 13) {
                        setTimeout(() => {
                            txtPassword.current.focus();
                        }, 100);

                    }
                } else {
                    setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'error al cargar el usuario', icono: 'informacion' });
                    setActivate(false);
                }

            }


        }).catch((error) => {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        })

    }

    useEffect(() => {
        let obj = JSON.parse(sessionStorage.getItem('post'));
    }, []);


    const blanquear = () => {

        setMostrar(false);
        setTitulo('');
        setMsg('');
        setMostrar1(false);
        setTitulo2('');
        setMsg2('');
        setActivate(false);
        setContar(0);
        setIdUsuario(0);

    }


    const cancelar = () => {
        blanquear();
        props.onHide();
    }

    const validarCapcha = () => {
        var valido = ValidCaptcha();
        if (valido) {

            setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: "Esta seguro de registrar el ejercicio fiscal con estos datos?", icono: 'confirmacion' });
            setMostrar4(false);
        }
    }

    const handleCancelaCapcha = () => {
        setMostrar4(false);
    }


    const handleCloseSi = () => {
        procesarRegistro();
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    }


    const seleccionarUsuario = () => {
        setContar(0);
        setActivate(true);
        SelectUsuario(txtLogin.current.value);
    };

    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        if (txtLogin.current.value.trim() === '') {
            setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'El Usuario no debe estar vacio', icono: 'informacion' });
            sigue = false;
            txtLogin.current.focus();
        } else if (txtPassword.current.value.trim() === '') {
            setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'La Contraseña no debe estar vacia', icono: 'informacion' });
            sigue = false;
            txtPassword.current.focus();
        } else if (txtConfirmPassword.current.value.trim() === '') {
            setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'La Confirmación de la Contraseña no debe estar vacia', icono: 'informacion' });
            sigue = false;
            txtConfirmPassword.current.focus();
        } else if (txtPassword.current.value.trim() !== txtConfirmPassword.current.value.trim()) {
            setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'Las Contraseñas no coinciden', icono: 'informacion' });
            sigue = false;
            txtConfirmPassword.current.focus();
        }
        if (sigue) {
            setActivate(true);
            setContar(0);
            let msg = '';
            if (props.operacion === 1) {
                msg = 'Esta Seguro de Registrar estos Datos.';
            } else if (props.operacion === 2) {
                msg = 'Esta Seguro de Modificar estos Datos.';
            } else if (props.operacion === 3) {
                msg = 'Esta Seguro de Eliminar estos Datos.';
            }

            setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: 'Esta Seguro de Cambiar la contrasena.', icono: 'confirmacion' });

        }

    };

    const handleInputChange = (event) => {
        setTecla(event.which);
        if (event.which === 13) {
            var valido;
            if (event.target.id === 'inputLogin') {
                seleccionarUsuario();
            } else if (event.target.id === 'inputPassword') {
                if (txtConfirmPassword.current.value !== '' && txtPassword.current.value !== txtConfirmPassword.current.value) {
                    setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'Las Contraseñas no coinciden', icono: 'informacion' });
                    txtPassword.current.focus();
                } else {
                    txtConfirmPassword.current.focus();
                }

            } else if (event.target.id === 'inputConfirmPassword') {
                if (txtConfirmPassword.current.value !== '' && txtPassword.current.value !== txtConfirmPassword.current.value) {
                    setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'Las Contraseñas no coinciden', icono: 'informacion' });
                    txtConfirmPassword.current.focus();
                } else {
                    btnAcepta.current.focus();
                }
            }
        } else if (typeof (event.which) === 'undefined') {
            if (event.target.id === 'inputPassword') {
                if (txtConfirmPassword.current.value !== '' && txtPassword.current.value !== txtConfirmPassword.current.value) {
                    setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'Las Contraseñas no coinciden', icono: 'informacion' });
                }
            } else if (event.target.id === 'inputConfirmPassword') {
                if (txtConfirmPassword.current.value !== '' && txtPassword.current.value !== txtConfirmPassword.current.value) {
                    setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'Las Contraseñas no coinciden', icono: 'informacion' });
                }
            }
        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;
    };

    const cerrarModal = () => {
        props.onHide();
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
    }

    const mostrarPassword = () => setMostrarClave(!mostrarClave);
    const mostrarPassword1 = () => setMostrarClave1(!mostrarClave1);

    return (
        <Modal
            {...props}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
              /*   txtLogin.current.value = props.usuario; */
                setDeshabilitado(false);
                setDeshabilitadoL(false);
                setDesde(0);
            }}
        >
            <Modal.Header className='azulGradiant2 header-modal'>
                <div className='fw-bold text-light'><h3>Cambio de Contraseña.</h3></div>
                <button ref={btnCancela} className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <MensajeCapcha
                    show={mostrar4}
                    onHideAcepta={validarCapcha} onHideCancela={handleCancelaCapcha} />
                <Dimmer active={activate} inverted>
                    <Loader inverted>cargando...</Loader>
                </Dimmer>
                <div style={{ height: "auto", overflow: "auto" }}>
                    <div className="border-azul rounded">
                        <div className="container">
                            <div className="col-md-12">

                                <div className="col-md-12 py-1">
                                    <label htmlFor="validationTooltipUsername">Usuario: </label>
                                    <input type="text" autocomplete="off" disabled ref={txtLogin} className="form-control form-control-sm" defaultValue={props.usuario ? props.usuario !== '' ? props.usuario : '' : ''} id="inputLogin" onKeyUp={handleInputChange} />
                                </div>

                                <div className="col-md-12 py-1">
                                    <label htmlFor="validationTooltip02">Contraseña: </label>
                                    <div className="input-group input-group-sm">
                                        <input type={mostrarClave ? 'text' : 'password'} disabled={deshabilitado} ref={txtPassword} className="form-control form-control-sm" id="inputPassword" onKeyUp={handleInputChange} />
                                        <button style={{ textAlign: "center", color: "white" }} disabled={deshabilitado} onClick={mostrarPassword} className="btn btn-sm btn-info"><i className="fa fa-eye-slash"></i> </button>
                                    </div>
                                </div>

                                <div className="col-md-12 py-1">
                                    <label htmlFor="validationTooltip03">Confirmar Contraseña: </label>
                                    <div className="input-group input-group-sm">
                                        <input type={mostrarClave1 ? 'text' : 'password'} disabled={deshabilitado} ref={txtConfirmPassword} className="form-control form-control-sm" id="inputConfirmPassword" onKeyUp={handleInputChange} />
                                        <button style={{ textAlign: "center", color: "white" }} disabled={deshabilitado} onClick={mostrarPassword1} className="btn btn-sm btn-info"><i className="fa fa-eye-slash"></i> </button>
                                    </div>
                                </div>
                                <div className='col-md-12 py-1'></div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="col-md-12">
                    <button ref={btnAcepta} onClick={onChangeValidar} className="btn btn-success col-md-6 btn-sm rounded-pill"><i className="fas fa-check-circle">  Aceptar</i></button>
                    <button ref={btnCancela} onClick={cancelar} className="btn btn-danger col-md-6 btn-sm rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
                </div>
            </Modal.Footer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Cambiar Contraseña' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        </Modal>
    );
}

//export default CambiarClave;


// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/modalCambiarClave.js